import api from './api';

export interface User {
  id: number;
  name: string;
  company: string;
  department: string;
  email: string;
  role: 'admin' | 'editor' | 'reviewer' | 'viewer';
  authProvider?: string;
  googleId?: string;
  createdAt: string;
  updatedAt: string;
  lastLoginAt?: string | null;
}

export interface PreRegisterUserDto {
  name: string;
  email: string;
  company: string;
  department?: string;
  role?: 'admin' | 'editor' | 'reviewer' | 'viewer';
}

export interface UpdateUserRoleDto {
  role: 'admin' | 'editor' | 'reviewer' | 'viewer';
}

/** 권한 부여 단위. EDR 은 화면별로 분리돼 있다 (IPT-628) */
export type PermissionPageType =
  | 'APT'
  | 'DLP'
  | 'NAC'
  | 'DAILY_REPORT'
  | 'WEB_FILTER'
  | 'EDR_THREAT'
  | 'EDR_REPORT';

export interface UserPermission {
  id: number;
  userId: number;
  companyName: string;
  pageType: PermissionPageType;
}

export const usersService = {
  getAll: async (): Promise<User[]> => {
    const response = await api.get<User[]>('/users');
    return response.data;
  },

  updateRole: async (userId: number, role: UpdateUserRoleDto): Promise<User> => {
    const response = await api.patch<User>(`/users/${userId}/role`, role);
    return response.data;
  },

  getUserPermissions: async (userId: number): Promise<UserPermission[]> => {
    const response = await api.get<UserPermission[]>(`/users/${userId}/permissions`);
    return response.data;
  },

  setUserPermissions: async (
    userId: number,
    permissions: Array<{ companyName: string; pageType: PermissionPageType }>,
  ): Promise<UserPermission[]> => {
    const response = await api.post<UserPermission[]>(`/users/${userId}/permissions`, {
      permissions,
    });
    return response.data;
  },

  delete: async (userId: number): Promise<void> => {
    await api.delete(`/users/${userId}`);
  },

  preRegister: async (data: PreRegisterUserDto): Promise<User> => {
    const response = await api.post<User>('/users/pre-register', data);
    return response.data;
  },
};

